<template #default="{}">
  <div v-show="deliverableDetail">
    <div id="social-modal-overlay">
      <div class="top" ref="overlayTop"></div>
      <div class="right" ref="overlayRight"></div>
      <div class="bottom" ref="overlayBottom"></div>
      <div class="left" ref="overlayLeft"></div>
    </div>
    <b-modal v-model="showSeriesManualUpdate" type="warn" title="Override Master Post?" @hide="seriesModalHidden($event)">
      <p>This post will no longer be automatically updated by changes to the master post. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="clickSeriesModalUpdate" :disabled="seriesManualUpdateDisabled">
          Edit Separately From Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickSeriesModalCancel" :disabled="seriesManualUpdateDisabled">
          Cancel
        </b-button>
        <b-button size="sm" variant="secondary" @click="clickSeriesModalViewMaster" :disabled="seriesManualUpdateDisabled">
          Edit Master
        </b-button>
      </template>
		</b-modal>
    <b-modal v-model="showSeriesRejoinMaster" type="warn" title="Rejoin Master Post">
      <p>Content for this post will be pulled from the master post, and any content or comments specific to this post will be lost. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="success" @click="clickConfirmRejoinMaster" :disabled="seriesRejoinMasterDisabled">
          Rejoin Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickCancelRejoinMaster" :disabled="seriesRejoinMasterDisabled">
          Cancel
        </b-button>
      </template>
		</b-modal>
    <b-modal v-model="showRemoveDeliverable" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this deliverable?</p>
    </b-modal>
    <div :class="socialModalClass">
      <b-tabs content-class="mt-3" class="social-modal-tabs" v-model="currentTab" ref="socialModalTabs">
        <b-tab title="Editor" active ref="tabEditor" title-item-class="tabEditorTitle">
          <template #title>
            <span class="nav-item-label">Editor</span>
          </template>

          <section class="settings campaign-settings">
            <div class="settings-header">

                <b-button v-b-toggle.collapse-social-campaign-dialog class="campaign-group-toggle">
                  <i class="fas fa-chevron-right collapse-indicator"></i>
                </b-button>
                  <SocialDeliverableCampaigns :key="`sdc-`+deliverableDetail.id" :deliverable="deliverableDetail" :disabled="showSocialCampaignSettings" @click-title="showSocialCampaignSettings = !showSocialCampaignSettings"/>
                  <SocialCampaignTitle :deliverable="deliverableDetail" :disabled="!showSocialCampaignSettings"  />

              <div v-if="isSocialCampaign && campaignDetailExists && 1 == 2">
                <b-button v-if="!showSocialCampaignSettings" v-b-toggle.collapse-social-campaign-dialog>Show Campaign</b-button>
                <b-button v-if="showSocialCampaignSettings" v-b-toggle.collapse-social-campaign-dialog>Hide Campaign</b-button>
              </div>
            </div>
            <b-collapse v-if="isSocialCampaign && campaignDetailExists" v-model="showSocialCampaignSettings" id="collapse-social-campaign-dialog" class="settings-content-collapse">
              <div class="settings-content">
                <SocialCampaignDialog :hideTitle="true" :hideDelete="true"/>
              </div>
            </b-collapse>
          </section>
          <section class="settings series-settings" v-if="isSocialSeries && seriesFetched">
            <div class="settings-header">

              	<b-button v-b-toggle.collapse-social-series-dialog class="campaign-group-toggle">
              	  <i class="fas fa-chevron-right collapse-indicator"></i>
              	</b-button>
              <SocialSeriesTitle :deliverable="socialSeriesDetail" :disabled="!showSocialSeriesSettings"/>
                <div class="pb-0 group-title-wrapper" v-show="!showSocialSeriesSettings" @click="showSocialSeriesSettings = !showSocialSeriesSettings">
              	<div class="type-label">Series</div>
              	<div class="group-title">
	                    <div class="group-title">
	                        <h1 class="mb-0 exclude-outside-click project-title" v-show="!editTitle">{{ socialSeriesDetail.title }}</h1>
	                    </div>
	                </div>
	            </div>


              <div class="settings-header-buttons" v-if="false">
                <b-button v-if="!showSocialSeriesSettings" v-b-toggle.collapse-social-series-dialog>Show Series</b-button>
                <b-button v-if="showSocialSeriesSettings" v-b-toggle.collapse-social-series-dialog>Hide Series</b-button>
              </div>
            </div>
            <b-collapse v-model="showSocialSeriesSettings" id="collapse-social-series-dialog" class="settings-content-collapse">
              <div class="settings-content">
                <SocialSeriesDialog :hideTitle="true" />
              </div>
            </b-collapse>
          </section>
          <section class="post-editor-section">
            <div class="details header">
              <div class="row">
                <div class="col-sm-6 col-md-8">
                	<label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
                	  <h2
                	  @click="activateTitleField"
                	  class="exclude-outside-click edit-d-title deliverable-title"
                	  v-show="!editTitle"
                	  >{{ deliverableDetail.title || 'Click to set...' }}</h2>
                	  <textarea
                	  v-click-outside="outside"
                	  ref="deliverableTitle"
                	  v-show="editTitle"
                	  v-model="deliverableDetail.title"
                	  type="text"
                	   :placeholder="getDeliverableTitlePlaceholder"
                	  class="form-control mb-3 title-field exclude-outside-click h2"
                	  @change="onUpdateDeliverableTitle"
                	    @blur="editTitle=false;"></textarea>
                	</label>
                	<div class="row">
                	  <div class="col">
                	    <label v-if="!isMobile()" class="form-group mb-0 w-100">
                	      <h2
                	      @click="activateTitleField"
                	      class="exclude-outside-click edit-d-title deliverable-title"
                	      v-show="!editTitle"
                	      >{{ deliverableDetail.title || 'Click to set...' }}</h2>
                	      <textarea
                	      v-click-outside="outside"
                	      ref="deliverableTitle"
                	      v-show="editTitle"
                	      v-model="deliverableDetail.title"
                	      type="text"
                	      :placeholder="getDeliverableTitlePlaceholder"
                	      class="form-control mb-3 title-field exclude-outside-click h2"
                	      @change="onUpdateDeliverableTitle"
                	        @blur="editTitle=false;"></textarea>
                	    </label>
                	  </div>
                	 </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <SocialStatusLabel :deliverable="deliverableDetail"/>
                </div>
              </div>
            </div>
            <!-- BEGIN Platforms/Language section -->
            <div class="details bubble">
              <div class="row social-settings-row">
                <div class="col-md-6">
                  <h3>Languages</h3>
                  <div class="social-settings-group">
                    <!--<h3>Languages</h3>-->
                    <fieldset class="lang social-settings">
                      <b-form-checkbox-group
                        v-model="selectedLanguages"
                        :options="checkboxLanguageOptions"
                        name="languages"
                        @change="selectedLanguagesUpdated"
                        :disabled="languagesDisabled"
                      ></b-form-checkbox-group>
                    </fieldset>
                  </div>
                </div>
                <div class="col-md-6">
                  <h3>Platforms</h3>
                  <div class="social-settings-group">
                    <!--<h3>Languages</h3>-->
                    <fieldset class="network social-settings">
                      <b-form-checkbox-group
                        v-model="selectedSocialNetworks"
                        :options="checkboxSocialNetworkOptions"
                        name="social-networks"
                        @change="selectedSocialNetworksUpdated"
                        :disabled="socialNetworksDisabled"
                      ></b-form-checkbox-group>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Platforms/Language section -->
            <div class="details bubble">
              <!--<div class="row">
                <div class="col-md-7">-->
                  <div v-if="isSocialSeriesMaster(deliverableDetail.id)" class="social-date-picker-wrap series">
                    <h3 class="posting-dates-title">Posting Dates & Times</h3>
                    <div :class="`series-post${seriesPostClass(seriesDeliverable)}`" v-for="seriesDeliverable in deliverableDetail.social_series_deliverables" v-if="!isSocialSeriesMaster(seriesDeliverable.id)" :key="'series-post-'+seriesDeliverable.id">
                      <SocialSeriesStatusBar :deliverable="seriesDeliverable" />
                      <SocialDatePicker :key="`'socialdatepicker'+deliverableDetail.id`"  :deliverableId="seriesDeliverable.id" :publishDate="seriesDeliverable.publish_date" :seriesDeliverables="deliverableDetail.social_series_deliverables" />
                      <!--<SocialSeriesPostToolbar :seriesDeliverable="seriesDeliverable" />-->
                      <SocialStatusLabel :deliverable="seriesDeliverable" />
                    </div>
                    <div class="new-series-post">
                      <!--
                      <b-collapse v-model="showNewDateTime" id="new-series-post-datetime">
                        <SocialDatePicker :seriesId="deliverableDetail.social_series[0]" :latestPost="deliverableDetail.social_series_deliverables.at(-1)" :seriesDeliverables="deliverableDetail.social_series_deliverables" />
                      </b-collapse>
                      -->
                      <b-modal id="seriesAddMultipleDates" title="Add Multiple Dates" size="lg" hide-footer>
                        <SocialMultiDatePicker :key="`'socialdatepickermulti'+deliverableDetail.id`"  :seriesId="deliverableDetail.social_series[0]" :latestPost="deliverableDetail.social_series_deliverables.at(-1)" :seriesDeliverables="deliverableDetail.social_series_deliverables" />
                      </b-modal>
                      <!-- 
                        <b-button v-if="!showNewDateTime" v-b-toggle.new-series-post-datetime variant="primary">Add Series Post</b-button>
                      -->
                      <b-button variant="primary" @click="clickSeriesAddMultipleDates">Add Multiple Dates</b-button>
                    </div>
                  </div>
                  <div v-else-if="isSocialSeries" class="social-date-picker-wrap single-post">
                    <h3>Posting Date & Time</h3>
                    <SocialDatePicker :key="'socialdatepicker'+deliverableDetail.id" :deliverableId="deliverableDetail.id" :publishDate="deliverableDetail.publish_date" :seriesDeliverables="deliverableDetail.social_series_deliverables" />
                    <b-button @click="clickSeriesModalViewMaster">Edit Master Post</b-button>
                    <b-button @click="clickSeriesRejoinMaster">Rejoin Master Post</b-button>
                  </div>
                  <div v-else class="social-date-picker" :id="'socialdatepicker-wrapper'+deliverableDetail.id">
                    <h3>Posting Date & Time</h3>

                    <SocialDatePicker :deliverableId="deliverableDetail.id" :key="'socialdatepicker'+deliverableDetail.id"  :publishDate="deliverableDetail.publish_date" />
                    <b-button @click="createSocialSeriesFromDeliverable">Create Series</b-button>
                  </div>
                  
                <!--</div>

                <div class="col-md-5">
                  <div class="social-settings-group">
                    <fieldset class="lang social-settings">
                      <b-form-checkbox-group
                        v-model="selectedLanguages"
                        :options="checkboxLanguageOptions"
                        name="languages"
                        @change="selectedLanguagesUpdated"
                        :disabled="languagesDisabled"
                      ></b-form-checkbox-group>
                    </fieldset>
                  </div>
                  <div class="social-settings-group">
                    <fieldset class="network social-settings">
                      <b-form-checkbox-group
                        v-model="selectedSocialNetworks"
                        :options="checkboxSocialNetworkOptions"
                        name="social-networks"
                        @change="selectedSocialNetworksUpdated"
                        :disabled="socialNetworksDisabled"
                      ></b-form-checkbox-group>
                    </fieldset>
                  </div>
                </div>
              </div>-->
            </div>
            <div class="form-group">
              <div class="tags__wrapper">
                <DeliverableListTags :deliverable="deliverableDetail" />
              </div>
            </div>

            <div class="details brief-editor">
              <h3>Brief</h3>
              <ckeditor
                editorUrl="/js/ckeditor/ckeditor.js"
                v-model="description"
                :id="'deliverable-description-'+deliverableDetail.deliverableId"
                :config="editorConfig"
                @blur="deliverableDescriptionUpdated"
                :editorDisabled="descriptionDisabled"
              ></ckeditor>
            </div>
            <div class="details post-editor">
              <div class="post-editor-wrap">
                <div class="post-editor-language" v-for="language in deliverableDetail.languages">
                  <div :class="`language-${ languages.find(lang => lang.id == language).lang_code }`">
                    <SocialPostEditor v-for="socialPost in deliverableDetail.social_posts" :key="socialPost.id" :lang="systemSettings.languages.find(lang => lang.id == language)" :post="socialPost" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="tasks-section">
            <div class="row">
              <div class="col-md-12">
                <div class="add-task-button-mobile">
                  <b-button v-if="canCreateTask()" variant="theme" class="add-task-btn" @click.stop="createTask">
                      Add Task
                      <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
                  </b-button>
                </div>
                <TaskFieldLabels ref="TaskFieldLabelsRef" :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" />
                <TaskFields :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" />
              </div>
            </div>
          </section>
          <section class="footer-controls-section">
            <button
              v-b-tooltip.hover
              :title="getDeleteDeliverableTitle"
              @click="removeDeliverable(deliverableDetail.deliverableId)"
              class="btn delete-deliverable-btn"
              v-if="userAbilities.deleteMediaCall && !deliverableDetail.permissions.viewOnly"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </section>
        </b-tab>
        <b-tab title="Comments" ref="tabComments" title-item-class="tabCommentsTitle">
          <template #title>
            <span class="nav-item-label">Comments</span>
          </template>
          <!--<SocialPostInfo />-->
          <section class="comments-section">
            <div class="language-group" v-for="language in deliverableDetail.languages">
              <h2 class="lang-title">{{systemSettings.languages.find(lang => lang.id == language).lang_name}}</h2>
              <div class="post-group" v-for="social_post in deliverableDetail.social_posts" v-if="social_post.lang_id == language">
                <b-button v-b-toggle="`comments-toggle-${social_post.id}`" class="post-group-toggle">
                  <i class="fas fa-chevron-right collapse-indicator"></i>
                  <!--<h3>Platform</h3>-->
                  <i v-for="network in social_post.social_networks" :class="`fab fa-${getSocialNetworkSlugFromId(network)} platform-indicator`"></i>
                  <span class="comment-count">
                    ({{ displayPostCommentCount(social_post) }})
                  </span>
                </b-button>
                <b-collapse visible :id="`comments-toggle-${social_post.id}`">
                  <div class="platform-group-content">
                    <div class="details post-image-details">
                      <!--<h4>Images</h4>-->
                      <div class="row">
                        <div class="col-md-6">
                          <span class="no-images" v-if="!social_post.files.length">No images.</span>
                          <div class="image-group" v-else>
                            <SocialPostImageSlider :socialPost="social_post" location="comments" />
                          </div>
                        </div>
                        <div class="col-md-6 comments-col">
                          <SocialPostCommentEditor :socialPost="social_post" :commentField="`image`" :key="'social-post-'+social_post.id+'-comments-image'" />
                        </div>
                      </div>
                    </div>
                    <div class="details post-caption-details">
                      <!--<h4>Caption</h4>-->
                      <div class="row">
                        <div class="col-md-6">
                          <span class="no-caption" v-if="!social_post.caption">No caption.</span>
                          <div class="caption-wrap">
                            {{ social_post.caption }}
                          </div>
                        </div>
                        <div class="col-md-6 comments-col">
                          <SocialPostCommentEditor :socialPost="social_post" :commentField="`caption`" :key="'social-post-'+social_post.id+'-comments-caption'" />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </section>
        </b-tab>
        <b-tab title="Summary" class="tab-pane__summary" ref="tabSummary" title-item-class="tabSummaryTitle">
          <template #title>
            <span class="nav-item-label">Summary</span>
          </template>
          <!--<SocialPostInfo />-->
          <section class="settings series-settings" v-if="isSocialSeries && seriesFetched && !deliverableDetail.is_master">
            <div class="settings-header">
              <div class="settings-header-title">
                <div class="department-label">Series:</div>
                <div class="department-title">{{socialSeriesDetail.title}}</div>
              </div>
              <div class="settings-header-buttons">
                <b-button @click="clickSeriesModalViewMaster">View Master Post</b-button>
              </div>
            </div>
          </section>
          <section class="summary-languages">
            <div v-for="language in deliverableDetail.languages" class="summary-language">
              <div class="summary-post" v-for="social_post in deliverableDetail.social_posts" v-if="social_post.lang_id == language">
                <div class="summary-post-header">
                  <h3 class="language-heading">{{systemSettings.languages.find(lang => lang.id == language).lang_name}}</h3>
                  <div class="platforms">
                    <h4>
                      <i v-for="network in social_post.social_networks" :class="`fab fa-${getSocialNetworkSlugFromId(network)} platform-indicator`"></i>
                    </h4>
                  </div>
                </div>
                <div class="summary-images social-image-slider">
                  <SocialPostImageSlider :socialPost="social_post" location="summary" />
                </div>
                <div class="summary-caption">
                  <div class="caption-text">
                    <span class="no-caption" v-if="!social_post.caption">No caption.</span>
                    <div class="caption-wrap" v-if="social_post.caption">
                      {{ social_post.caption }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="summary-schedule">
            <SocialSummarySchedule :deliverable="deliverableDetail" />
          </section>
          <section class="summary-controls">
          
            <SocialSummaryControls />
          </section>
        </b-tab>
        <b-tab :title-link-class="'close-tab-link'" :title-item-class="'close-tab'" @click="onCloseModal">
          <template #title>
            <i class="fas fa-times"></i>
          </template>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DeliverableCustomFields from "../common/DeliverableCustomField";
import FullContactField from "../common/FullContactField";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import UpdateContactModal from "./EditContactModal";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableDepartments from "./DeliverableDepartments";
import Format from "../../utility/Format";
import Autocomplete from '@trevoreyre/autocomplete-vue'
import CreateLinkModal from "./CreateLinkModal";
import FeedbackBtn from "../common/FeedbackBtn"
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn"
import EditLinkModal from "./EditLinkModal";
import toast from "../../toast";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import SocialPostInfo from "./SocialPostInfo.vue";
import SocialPostCommentEditor from "./SocialPostCommentEditor.vue";
//import SocialPostCommentImage from "./SocialPostCommentImage.vue";
//import SocialPostCommentImages from "./SocialPostCommentImages.vue";
import SocialPostImageSlider from "./SocialPostImageSlider.vue";
import SocialPostEditor from "./SocialPostEditor.vue";
import SocialSummaryControls from "./SocialSummaryControls.vue";
import SocialSummaryPost from "./SocialSummaryPost.vue";
import SocialSummarySchedule from "./SocialSummarySchedule.vue";
import SocialStatusLabel from "./SocialStatusLabel.vue";
import SocialDatePicker from "./SocialDatePicker.vue";
import SocialMultiDatePicker from "./SocialMultiDatePicker.vue";
//import SocialSeriesPostToolbar from "./SocialSeriesPostToolbar.vue";
import SocialSeriesStatusBar from "./SocialSeriesStatusBar.vue";
import SocialSeriesHeader from "./SocialSeriesHeader.vue";
import SocialSeriesDialog from "./SocialSeriesDialog.vue";
import SocialCampaignDialog from "./SocialCampaignDialog.vue";
import SocialCampaignTitle from "./SocialCampaignTitle.vue";
import SocialSeriesTitle from "./SocialSeriesTitle.vue";


import SocialDeliverableCampaigns from "./SocialDeliverableCampaigns.vue";
import { lang } from "vue-moment";
import { watch, ref } from 'vue';


export default {
  data() {
    return {
      Format,
      title: "",
      description: "",
      descriptionDisabled: false,
      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      //dateFormat: "YYYY-MM-DD HH:mm",
      dateFormat: "MMMM Do YYYY, h:mm a",
      addingTask: true,
      showModalOptions: false,
      renderCount: 1,
      newContactId: "",
      newContactName: "",
      editTitle: false,
      originalTitle:null,
      addContactFlag: false,
      addWhoFlag:false,
      addSpokespersonFlag:false,
      showRemoveDeliverable: false,
      showRemoveContact:false,
      showRemoveSpokesperson:false,
      showRemoveWho:false,
      showRemoveResource:false,
      addResourceFlag:false,
      contacts:[],
      linkUrl:null,
      linkLabel:null,
      linkNotes:null,
      linkType:null,
      filepond: [],
      editLinkIsFile: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},
      postImages: [],
      selectedLanguages: [],
      selectedSocialNetworks: [],
      languagesDisabled: false,
      socialNetworksDisabled: false,
      carouselInterval: 3000,
      showNewDateTime: false,
      showSeriesManualUpdate: false,
      showSeriesRejoinMaster: false,
      seriesManualUpdateDisabled: false,
      seriesRejoinMasterDisabled: false,
      showSocialCampaignSettings: false,
      showSocialSeriesSettings: false,
      contentDiv: null,
      currentTab: 0,
      overlayInterval: null,
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      }
    };
  },
  components: {
    DeliverableProjects,
    DeliverableCustomFields,
    TaskFields,
    TaskFieldLabels,
    UpdateContactModal,
    DeliverableListTags,
    DeliverableDepartments,
    FullContactField,
    Autocomplete,
    EditLinkModal,
    FeedbackBtn,
    DuplicateMediaCallBtn,
    CreateLinkModal,
    LinkCopyLinkModal,
    SocialPostInfo,
    SocialPostCommentEditor,
    //SocialPostCommentImage,
    //SocialPostCommentImages,
    SocialPostImageSlider,
    SocialPostEditor,
    SocialSummaryControls,
    SocialSummaryPost,
    SocialSummarySchedule,
    SocialStatusLabel,
    SocialDatePicker,
    SocialMultiDatePicker,
    //SocialSeriesPostToolbar,
    SocialSeriesStatusBar,
    SocialSeriesHeader,
    SocialSeriesDialog,
    SocialCampaignDialog,
    SocialCampaignTitle,
    SocialSeriesTitle,
    SocialDeliverableCampaigns
  },
  props: ["allContacts", "modalId", "tabIndex"],
  computed: {
    ...mapGetters([
    "allDepartments",
    "allSubjects",
    "deliverableDetail",
    "allTags",
    "allRegions",
    "deliverableContactsLabel",
    "allCustomFields",
    "initialContacts",
    "userAbilities",
    "deliverableTypes",
    "allCustomFields",
    "systemSettings",
    "socialSeriesDetail",
    "socialCampaignDetail"
    ]),
    console: () => console,
    // so that we can use lodash in the template
    _() {
      return _;
    },
    checkboxLanguageOptions(){
      let languageOptions = [];
      if (this.systemSettings.languages){
        this.systemSettings.languages.forEach(function(lang){
          languageOptions.push({
            html: lang.lang_code,
            value: lang.id,
          })
        })
      }
      return languageOptions;
    },
    languages(){
      let computedLanguages = [];
      if(this.systemSettings.languages){
        computedLanguages = this.systemSettings.languages;
      }
      return computedLanguages;
    },
    checkboxSocialNetworkOptions(){
      let socialNetworkOptions = [];
      if(this.systemSettings.social_networks){
        this.systemSettings.social_networks.forEach(function(network){
          socialNetworkOptions.push({
            html: "<i class='fab fa-"+network.api_type+"'></i>",
            value: network.id,
          });
        })
      }
      return socialNetworkOptions;
    },
    networks(){
      let computedNetworks = [];
      if(this.systemSettings.social_networks){
        computedNetworks = this.systemSettings.social_networks;
      }
      return computedNetworks;
    },
    socialModalClass(){
      let modalClass = "edit-social-deliverable-modal";
      if(this.isSocialSeriesMaster(this.deliverableDetail.id)){
        modalClass = modalClass + " master-deliverable";
      }
      return modalClass
    },
    getDeliverableTitlePlaceholder() {
    	if (this.deliverableDetail) {
        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
	    	if (this.deliverableDetail.deliverable_template_id == 1) {
	    		return "Media call title...";
	    	} else {
          if (deliverableTypeObj) {
            return deliverableTypeObj.name + " title...";
          } else {
            return "Deliverable title...";
          }
	    	}
	    }
    },

    getDeleteDeliverableTitle() {
    	if (this.deliverableDetail) {

        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
	    	if (this.deliverableDetail.deliverable_template_id == 1) {
	    		return "Delete Media Call";
	    	} else {
          if (deliverableTypeObj) {
            return "Delete " + deliverableTypeObj.name;
          } else {
            return "Delete Deliverable";
          }
	    	}
	    }
    },
    token(){
      return this.$store.getters.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags,
      relatedTags = [];
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function(e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },

    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
		},

    displayPublishDate() {
      //let date = this.$moment.utc(this.deliverableDetail.publish_date).local().format("MMMM Do YYYY, h:mm a");
      let date = this.$moment.utc(this.deliverableDetail.publish_date).local().format(this.dateFormat);
      if(date == "Invalid date"){
        return "No date set";
      }
      return date;
    },

    isSocialSeries(){
    	if (this.deliverableDetail.social_series) {
	      if(this.deliverableDetail.social_series.length){
          //console.log("deliverable is part of series");
	        return true;
	      }
	    }
      return false;
    },

    seriesFetched(){
      if(Object.keys(this.socialSeriesDetail).length){
        return true;
      }
      return false;
    },

    isSocialCampaign(){
      if(this.deliverableDetail.social_campaigns){
	      if(this.deliverableDetail.social_campaigns.length){
	        return true;
	      }
	    }
      return false;
    },

    campaignDetailExists(){
      if(this.socialCampaignDetail){
        if(Object.keys(this.socialCampaignDetail).length){
          return true;
        }
      }
      return false;
    },

    isManuallyUpdated() {
      if(this.deliverableDetail.manually_updated_at != null){
        return true;
      }
      return false;
    },

  },
  methods: {
    ...mapActions([
    "updateFieldValue",
    "createTag",
    "removeDeliverableContact",
    "removeDeliverableWho",
    "removeDeliverableSpokesperson",
    "fetchUserManageSocialCampaigns",
    "fetchSocialCampaigns",
    "updateDeliverableTitle"
    ]),
    ...mapMutations([
      "setDeliverable",
      "setDeliverableDetail"
    ]),

    canCreateTask() {
    	let flag = false;
   		 if(this.userAbilities.editMediaCall || this.deliverableDetail.permissions) {
   		 		return !this.deliverableDetail.permissions.viewOnly;
   			}
    	return flag;
  	},


    onUpdateDeliverableTitle() {
    	let testTitle = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
    	testTitle = testTitle.trim();
    	if (testTitle == null || testTitle == "") {
    		testTitle = this.originalTitle;
    	}
      this.deliverableDetail.title = testTitle;
      this.updateDeliverableTitle(this.deliverableDetail);
    },
    activateTitleField() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      let that = this
      this.editTitle=true;

      if (this.originalTitle == null) {
      	this.originalTitle = this.deliverableDetail.title;
      }
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
      this.addContactFlag = false;
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableContacts.$el.focus();
      });
    },
    showAddResource() {
      this.addResourceFlag = true;
      this.$nextTick(() => {
        // this.$refs.deliverableResources.$el.focus();

      });
    },

    showAddWho() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addWhoFlag = true;
      this.$nextTick(() => {
        this.$refs.searchWho.$refs.input.focus();
      });
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddSpokesperson() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addSpokespersonFlag = true;
      this.$nextTick(() => {
        this.$refs.searchSpokesperson.$refs.input.focus();
      });
    },
    onContactSearch(input) {
      this.isLoading = true;
      this.contacts = [];
      if (input.length < 1) {
        this.isLoading = false;
      }  else {
        axios.get(process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input))
        .then(resp => {
          this.contacts = [];
          for(var contact of resp.data) {
            contact.name = contact.first_name +  " " + contact.last_name;
            contact.commaName = contact.last_name + ", " + contact.first_name;
            this.contacts.push(contact);
          }
          this.isLoading = false;
        })
      }
    },
    contactCustomLabel ({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },

    onSpokespersonSearch(input) {
      // if(!input && this.initialContacts.length > 0) {
      //     return this.initialContacts;
      // } else {
        return new Promise((resolve, reject) => {
          input = input == false ? '' : input
          axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
          .then(resp => {
            let contacts = [];
            let x = 0;
            contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
            for (x = 0 ; x < resp.data.length; x++) {
              contacts.push(resp.data[x]);
            }
            this.$store.commit('setInitialData', {contacts: contacts})
            resolve(contacts);
          })
          .catch(error => {
            reject(error)
          })
        }) 
      // }
    },
    onSpokespersonSelect(selected) {
      if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createSpokesperson(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('spokesperson');
        }
        this.$refs.searchSpokesperson.value = null;
        this.addSpokespersonFlag = false;
      },



      onWhoSearch(input) {
        // if(input == '' && this.initialContacts.length > 0) {
        //   return this.initialContacts;
        // } else {
          return new Promise((resolve, reject) => {
            input = input == false ? '' : input
            axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
            .then(resp => {
              let contacts = [];
              let x = 0;
              contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
              for (x = 0 ; x < resp.data.length; x++) {
                contacts.push(resp.data[x]);
              }
              this.$store.commit('setInitialData', {contacts: contacts})
              resolve(contacts);
            })
            .catch(error => {
              reject(error)
            })
          })
        // }
      },
      onWhoSelect(selected) {
        if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createWho(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('who');
        }
        this.$refs.searchWho.value = null;
        this.addWhoFlag = false;
      },

      getResourceValue(url, parent_id) {
        let label = this.customChildFieldValue('link_label',parent_id);
        let notes = this.customChildFieldValue('link_notes',parent_id);
        let fileId = this.customChildFieldValue('file_id',parent_id);
        if (url == null && fileId != null && label) {
          return `<a href="${this.apiUrl}downloadFileDeliverable/${this.deliverableDetail.id}/${fileId}" target="blank">${label}</a>`
        }
        if (url != "" && label != "" && label) {
          return "<a href=\""+url+"\" @click.prevent=\"openCopyLinkModal(\""+url+"\")\" target=\"blank\">"+label+"</a>";
        }
        if (url != "" && url) {
          return "<a href=\""+url+"\" target=\"blank\">"+url+"</a>";
        }
        if (label != "" && label) {
          return label;
        }
        return "";
      },

      openCopyLinkModal(link, e, i) {
        if (!link.includes("\\")) {
          return;
        }
        e.preventDefault();
        // this.linkCopyModalValue = link;
        // this.$bvModal.show("linkCopyLinkModal");
        this.copyLink(link, i);
      },
      async copyLink(link, resourceId) {
        clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
        Object.keys(this._.filter(this.deliverableDetail.customFields, {field_key: 'link_url'})).forEach(x => {
          if (x == resourceId) return;
          this.$root.$emit('bv::hide::tooltip', 'resource-' + x);
        })

        const navPer = await navigator.permissions.query({name: "clipboard-write"});
        if (navPer.state == "granted" || navPer.state == "prompt") {
            try {
                await navigator.clipboard.writeText(link);
            } catch {
                console.error("clipboard API error. Cannot copy to clipboard.");
                this.legacyCopyMethod(link);
            }
        } else {
          this.legacyCopyMethod(link);
        }

        this.$root.$emit('bv::show::tooltip', 'resource-' + resourceId);
        this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
          this.$root.$emit('bv::hide::tooltip', 'resource-' + resourceId);
        }, 2000);
      },
      legacyCopyMethod(link) {
        let tempInput = document.createElement("input");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      },


      customChildField(key, parent_id) {
        if (this.deliverableDetail.customFields) {
          let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            // return the global version of the custom field...
            // let obj = _.filter(this.allCustomFields, {field_key: key});
            let field = _.filter(this.allCustomFields, {field_key: key});


            if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            	return null;
            } else {
	            obj = {};
	            obj.id = null;
	            obj.parent_id = this.deliverableDetail.customFields[key].id;
	            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
	            obj.editing = false;
	            obj.field_id = field[0].id;
	            obj.field_key = field[0].field_key;
	            obj.field_parent_id = field[0].parent_id;
	            obj.field_type = field[0].field_type;
	            obj.note = field[0].note;
	            obj.value = null;
	            obj.label = field[0].label;
	            obj.value_set = field[0].value_set;
	            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
	           }
	           return [obj];
          }
      }
      return [];
    },


    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj != null) {
	        if (obj.length > 0) {
	          return obj[0].value;
	        } else {
	          return null;
	        }
	      }
      }
      return null;
    },



    createContact(newContactName) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createContactModal");
      //this.$store.commit("toggleAddContactModal");
    },
    createSpokesperson(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'spokesperson';
      this.$bvModal.show("createSpokespersonModal");
      //this.$store.commit("toggleAddContactModal");
    },
    createWho(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createWhoModal");
      //this.$store.commit("toggleAddContactModal");
    },

    updateContact(contactData, fieldKey) {
      this.$store.state.currentContactData = contactData;
      this.$store.state.currentContactId = contactData.id;
      this.$store.state.currentFieldKey = fieldKey;
      if (fieldKey == 'who') {
        this.$bvModal.show("editWhoModal");
      }
      if (fieldKey == 'spokesperson') {
        this.$bvModal.show("editSpokespersonModal");
      }
      //this.$store.commit("toggleEditContactModal");
    },


    editResource(resource) {
      this.linkUrl = resource;
      let label =  this.customChildField('link_label', resource.id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes =  this.customChildField('link_notes', resource.id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type =  this.customChildField('link_type', resource.id);
      if (type && type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id:null,
          field_id:37,
          parent_field_id:20,
          field_key:"link_type",
          field_type:"select",
          parent_id:null,
          deliverable_id:this.deliverableDetail.deliverableId,
          value:1
        };
      }
      let fileId = this.customChildField('file_id', resource.id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editLinkModal");
    },


    addResource(typeId = 1) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.linkUrl = {
        id:null,
        field_id:20,
        parent_field_id:null,
        field_key:"link_url",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkLabel = {
        id:null,
        field_id:21,
        parent_field_id:20,
        field_key:"link_label",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkNotes = {
        id:null,
        field_id:22,
        parent_field_id:20,
        field_key:"link_notes",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkType = {
        id:null,
        field_id:37,
        parent_field_id:20,
        field_key:"link_type",
        field_type:"select",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:typeId
      };
      this.$bvModal.show("createLinkModal");
    },
    addResourceMenuItemClick(typeId, e) {
      e.preventDefault();
      this.addResource(typeId);
    },



    contactsNotAdded(field_key) {
      let addedContacts = _.filter(this.deliverableDetail.customFields, {
        field_key: field_key
      }),
      allContacts = this.allContacts,
      addedIds = [];

      _.forEach(addedContacts, function(n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function(o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },
    inputAddContact(field_key) {
      let x = 0;
      let field_id = null;
      for(x = 0; x < this.deliverableDetail.customFields.length; x++) {
        if (this.deliverableDetail.customFields[x].field_key == field_key) {
          field_id = this.deliverableDetail.customFields[x].field_id;
          break;
        }
      }
      this.newContactId.fieldId = field_id;
      switch(field_key) {
        case "who":
        this.addDeliverableWho({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        case "spokesperson":
        this.addDeliverableSpokesperson({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        default:
      }
    },
    addDeliverableSpokesperson(payload) {
      this.$store.dispatch("addDeliverableSpokesperson", payload);
      this.newContactId = "";
    },
    addDeliverableWho(payload) {
      this.$store.dispatch("addDeliverableWho", payload);
      this.newContactId = "";
    },

    addDeliverableContact(payload) {
      this.$store.dispatch("addDeliverableContact", payload);
      this.newContactId = "";
    },
    removeDeliverable(deliverableId) {
      this.showRemoveDeliverable = true;
    },
    onConfirmRemoveDeliverable() {
      if (this.deliverableDetail.deliverableId) {
        let that = this;
        // let deliverableId = this.deliverableDetail.deliverableId;
        // let deliverableTemplateId = this.deliverableDetail.deliverable_template_id;
        this.$store.dispatch("removeDeliverable", { deliverableId:this.deliverableDetail.deliverableId }).then(function() {
          that.$bvModal.hide("editSocialModal");
          // TODO: removing a deliverable should only remove it from the list, not replace entire list.
          // that.$store.commit('removeMediaCallFromList', deliverableId);
          // that.$store.dispatch('countOutlets');
          let action = 'fetchDeliverables';
          if(
            that.$router.currentRoute.name == 'socialMedia' ||
            that.$router.currentRoute.name == 'socialMediaGrouped'
          ) {
            action = 'fetchSocialMediaDeliverablesGrouped';
          } else if(that.$router.currentRoute.name == 'socialMediaSchedule') {
            action = 'fetchCalendarDeliverables';
          }
          that.$store.dispatch(action).then(function() {
            toast.hide();
            that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
          });
        });
      }
    },
    showRemoveDeliverableContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableContact(this.contactId);
      }
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },

    onShowRemoveSpokesperson(contactId) {
      this.contactId = contactId;
      this.showRemoveSpokesperson = true;
    },
    onConfirmRemoveSpokesperson() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

    onShowRemoveWho(contactId) {
      this.contactId = contactId;
      this.showRemoveWho = true;
    },
    onConfirmRemoveWho() {
      if (this.contactId) {
        this.removeDeliverableWho(this.contactId);
      }
    },

    onCloseModal() {
      if (this.modalId) {
        this.$bvModal.hide(this.modalId);
      } else { 
        this.$bvModal.hide("editSocialModal");
      }
      if(this.$router.currentRoute.name == 'calendar') {
        this.$root.$emit('re__fetch__calendar__data')
      }
    },

    setTag(newTag) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      // this.renderCount++;
      // this.relatedTags = _.remove(this.relatedTags, function(e) {
      //   return e.id == newTag.id;
      // });
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch("updateFieldValue", this.deliverableDetail);
    },

    hasContactFields() {
      // let r = _.filter(this.deliverableDetail.customFields, {field_type: 'contacts'});

      // Hardcode for now (filter out contacts field will kill the contact box for other deliverable types as well)
      // return this.deliverableDetail.deliverable_template_id != 8;
      return this.deliverableDetail.deliverable_template_id == 1;
    },

    // Hardcode
    showDepartment() {
      // return this.deliverableDetail.deliverable_template_id != 8;
      return this.deliverableDetail.deliverable_template_id == 1;
    },

    // Resource upload file
    handleFilePondInit() {
      this.$refs.resourcePond._pond.setOptions({
        server: {
          headers: {
            Authorization: "Bearer " + this.$store.getters.authToken
          },
          process: {
            method: 'POST',
            url: `${this.apiUrl}uploadFileDeliverable`,
            withCredentials: true,
            ondata: this.handleFilePondSubmit,
            onload: this.handleFilePondSuccess,
          },
        }
      });
    },
    handleFilePondSubmit(data) {
      // data.append('type', 1);
      data.append('id', this.deliverableDetail.id);
      return data;
    },
    handleFilePondSuccess(r) {
      let newDeliverableR = JSON.parse(r);
      this.setDeliverable(newDeliverableR.deliverableDetail);
      this.setDeliverableDetail(newDeliverableR.deliverableDetail);
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    createTask() {
      this.$refs.TaskFieldLabelsRef.createTask();
    },

    deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},

    deliverableTitleUpdated(e){
      let that = this;
      if(
        this.title.trim() != this.deliverableDetail.title.trim() &&
        this.title.trim() != "" && 
        !e.target.hasAttribute("disabled")
      ){
        e.target.setAttribute("disabled", true);
        that.$store.dispatch("updateDeliverableTitle", {
          id: that.deliverableDetail.id,
          title: that.title
        }).then(function(){
          e.target.removeAttribute("disabled");
        });
      }
    },

    deliverableDescriptionUpdated(){
      let that = this;
      if(
        this.description.trim() != this.deliverableDetail.description.trim() &&
        this.description.trim() != "" && 
        !this.descriptionDisabled
      ){
        that.descriptionDisabled = true;
        that.$store.dispatch("updateDeliverableDescription", {
          id: that.deliverableDetail.id,
          description: that.description
        }).then(function(){
          that.descriptionDisabled = false;
        });
      }
    },

    selectedLanguagesUpdated(){
      let that = this;
      if(that.selectedLanguages.length == 0){
        that.selectedLanguages = this.deliverableDetail.languages;
      } else {
        let addLanguages = that.selectedLanguages.filter(x => !that.deliverableDetail.languages.includes(x));
        let removeLanguages = that.deliverableDetail.languages.filter(x => !that.selectedLanguages.includes(x));
        if(addLanguages.length){
          that.languagesDisabled = true;
          that.$store.dispatch("addDeliverableLanguage", {
            id: that.deliverableDetail.id,
            lang_id: addLanguages[0]
          }).then(function(){
            that.languagesDisabled = false;
          });
        } else if(removeLanguages.length){
          that.languagesDisabled = true;
          that.$store.dispatch("removeDeliverableLanguage", {
            id: that.deliverableDetail.id,
            lang_id: removeLanguages[0]
          }).then(function(){
            that.languagesDisabled = false;
          });
        } else {
          console.log("Error, no language to add or remove");
        }
      }
    },

    selectedSocialNetworksUpdated(){
      if(this.selectedSocialNetworks.length == 0){
        this.selectedSocialNetworks = this.deliverableDetail.social_networks;
      } else {
        let addSocialNetworks = this.selectedSocialNetworks.filter(x => !this.deliverableDetail.social_networks.includes(x));
        let removeSocialNetworks = this.deliverableDetail.social_networks.filter(x => !this.selectedSocialNetworks.includes(x));
        if(addSocialNetworks.length){
          this.socialNetworksDisabled = true;
          this.$store.dispatch("addDeliverableSocialNetwork", {
            id: this.deliverableDetail.id,
            social_network_id: addSocialNetworks[0]
          });
        } else if(removeSocialNetworks.length){
          this.socialNetworksDisabled = true;
          this.$store.dispatch("removeDeliverableSocialNetwork", {
            id: this.deliverableDetail.id,
            social_network_id: removeSocialNetworks[0]
          });
        } else {
          console.log("Error, no social network to add or remove");
        }
      }
    },

    getSocialNetworkSlugFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.api_type;
    },

    /*
    dateTimeUpdated(){
      console.log("Date/Time updated");
      if(this.postDate.length && this.postTime.length){
        
        let that = this;
        let selection = that.postDate+" "+that.postTime;
        let utc = this.$moment(selection).utc().format(this.dateFormat);

        this.dateTimeDisabled = true;
        this.$store.dispatch("updateDeliverablePublishDate", {
          id: that.deliverableDetail.id,
          value: utc
        }).then(function(){
          that.dateTimeDisabled = false;
        });
        
      }
      
    },
    */
    isSocialSeriesMaster(id){
      let master_id = this.getSocialSeriesMasterId();
      if(master_id === id){
        return true;
      }
      return false;
    },
    getSocialSeriesMasterId(){
      let series = this.deliverableDetail.social_series_deliverables;
      if (series) {
	      if(series.length){
	        let master = series.find(x => x.is_master === 1);
	        if(master){
	          return master.id;
	        }
	      }
	    }
      return false;
    },
    resetNewDatePicker(){
      //console.log("Try to reset new post datepicker");
    },
    seriesPostClass(post){
      let postDate = this.$moment(post.publish_date).local();
      let today = this.$moment();
      if(postDate.isSame(today, "day")){
        return " today";
      }
      return "";
    },
    createSocialSeriesFromDeliverable(){
      let data = {
        title: this.deliverableDetail.title,
        from_deliverable_id: this.deliverableDetail.id
      }
      this.$store.dispatch("createSocialSeries", data);
    },
    clickSeriesModalUpdate(){
      let that = this;
      this.seriesManualUpdateDisabled = true;
      this.$store.dispatch("setAsManuallyUpdated", {
        id: that.deliverableDetail.id
      }).then(function(){
        that.showSeriesManualUpdate = false;
        that.$store.dispatch('manageUndoActivation', 'Editing separately from Master Post');
      });
      this.$store.dispatch('manageUndoActivation', 'Editing separately from Master Post');

    },
    clickSeriesModalCancel(){
      this.showSeriesManualUpdate = false;
      this.$bvModal.hide("editSocialModal");
    },
    clickSeriesModalViewMaster(){
      let that = this;
      
      let masterId = that.getSocialSeriesMasterId();
      this.$store.dispatch("getDeliverableDetail", {deliverableId: masterId}).then(function(){
        console.log("Master loaded");
      });
    },
    clickSeriesRejoinMaster(){
      this.showSeriesRejoinMaster = true;
    },
    clickCancelRejoinMaster(){
      this.showSeriesRejoinMaster = false;
    },
    clickConfirmRejoinMaster(){
      this.$store.dispatch("setAsAutomaticallyUpdated", {id: this.deliverableDetail.id}).then(function(){
        console.log("deliverable rejoined with master");
      });
    },
    clickSeriesAddMultipleDates(){
      this.$bvModal.show("seriesAddMultipleDates");
    },
    seriesModalHidden(event){
      if(event.trigger != null){
        this.$bvModal.hide("editSocialModal");
      }
    },
    displaySeriesPublishDate(seriesPost){
      if(seriesPost){
        //let date = this.$moment.utc(seriesPost.publish_date).local().format("MMMM Do YYYY, h:mm a");
        let date = this.$moment.utc(seriesPost.publish_date).local().format(this.dateFormat);
        if(date == "Invalid date"){
          return "No date set";
        }
        return date;
      }
    },
    displayPostCommentCount(post){
      let count = post.comments.length;
      let label = "Comments";
      if(count === 1){
        label = "Comment";
      }
      return count + " " + label;
    },
    initializeSocialModal(){
      let that = this;
      this.seriesManualUpdateDisabled = false;
      this.seriesRejoinMasterDisabled = false;
      this.showSeriesManualUpdate = false;
      this.showSeriesRejoinMaster = false;
      if(this.isSocialSeries && 
        !this.isSocialSeriesMaster(this.deliverableDetail.id) && 
        !this.isManuallyUpdated
      ){
        this.showSeriesManualUpdate = true;
      }
      this.resetNewDatePicker();
      this.showNewDateTime = false;
      this.selectedLanguages = this.deliverableDetail.languages;
      this.languagesDisabled = false;
      this.socialNetworksDisabled = false;
      this.selectedSocialNetworks = this.deliverableDetail.social_networks;

      if(this.deliverableDetail.title == null){
        this.deliverableDetail.title = "";
      }
      this.title = this.deliverableDetail.title;

      if(this.deliverableDetail.description  == null){
        this.deliverableDetail.description = "";
      }
      this.description = this.deliverableDetail.description;

      
      if(this.isSocialSeries){
        this.$store.dispatch("getSocialSeriesDetail", {
          seriesId: this.deliverableDetail.social_series[0]
        });
      }
      if(this.isSocialCampaign){
        this.$store.dispatch("fetchSocialMediaCampaignDetail",
          this.deliverableDetail.social_campaigns[0]
        );
      } else {
        this.$store.commit("setSocialCampaignDetail", null);
        this.showSocialCampaignSettings = false;
      }

      
      this.overlayListener();
    },

    escapeListener(e){
      if (e.key == 'Escape') {
        console.log("Esc key pressed");
        this.onCloseModal();
      }
    },

    overlayListener(){
      if(!this.contentDiv){
        return;
      }

      let olTop = this.$refs.overlayTop;
      let olRight = this.$refs.overlayRight;
      let olBottom = this.$refs.overlayBottom;
      let olLeft = this.$refs.overlayLeft;

      if(!olTop || !olRight || !olBottom || !olLeft){
        return;        
      }

      let header = document.querySelector("#header__controls");
      let activeRow = document.querySelector(".deliverable-listing.social-media .row.active");
      
      
      let contentRect = this.contentDiv.getBoundingClientRect();
      let contentWidth = this.contentDiv.clientWidth;
      let contentHeight = this.contentDiv.clientHeight;


      if(activeRow && header){
        let rowRect = activeRow.getBoundingClientRect();
        let headerRect = header.getBoundingClientRect();

        if(olTop){

          olTop.style.top = 0;
          olTop.style.left = contentRect.left + "px";
          olTop.style.width = contentWidth + "px";
          olTop.style.height = rowRect.top + "px";
          if(rowRect.bottom <= headerRect.bottom){
            olTop.style.height = 0;
          } else if (rowRect.top >= contentHeight){
            olTop.style.height = contentHeight + "px";
          } else if (rowRect.top <= headerRect.height){
            olTop.style.height = headerRect.height + "px";
          }
        }


        if(olBottom){
        	let x = 0;
          olBottom.style.top = rowRect.bottom + "px";
          olBottom.style.left = contentRect.left + "px";
          olBottom.style.width = contentWidth + "px";
        	let h = (contentHeight - rowRect.bottom);
        	if (h > 0) {
          	olBottom.style.height = h + "px";
          }
          if(contentHeight - rowRect.bottom <= 0){
            olBottom.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olBottom.style.height = contentHeight + "px";
            olBottom.style.top = 0;
          } else if (rowRect.top > 0 && rowRect.bottom <= headerRect.bottom){
            //olBottom.style.height = 
          }
        }
        if(olLeft){
          olLeft.style.left = contentRect.left + "px";
          let w = (rowRect.left - contentRect.left);
          if (w > 0) {
          	olLeft.style.width = w + "px";
          }


          if(rowRect.left - contentRect.left <= 0){
            olLeft.style.width = 0;
          }
          olLeft.style.top = rowRect.top + "px";
          olLeft.style.height = rowRect.height + "px"
          if(rowRect.top >= contentHeight){
            olLeft.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olLeft.style.height = 0;
          } else if(rowRect.top <= headerRect.bottom){
            olLeft.style.height = (rowRect.bottom - headerRect.bottom) + "px";
            olLeft.style.top = headerRect.bottom + "px";
          } else if(rowRect.bottom >= contentHeight){
            olLeft.style.height = (contentHeight - rowRect.top) + "px";
          }
        }


        if(olRight){
          olRight.style.left = rowRect.right + "px";

          let w = (contentRect.left + contentWidth - rowRect.right)
          if (w > 0) {
          	olRight.style.width = w + "px";
          }

          if(contentRect.left + contentRect.width - rowRect.right <= 0){
            olRight.style.width = 0;
          }
          olRight.style.top = rowRect.top + "px";
          olRight.style.height = rowRect.height + "px"
          if(rowRect.top >= contentHeight){
            olRight.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olRight.style.height = 0;
          } else if(rowRect.top <= headerRect.bottom){
            olRight.style.height = (rowRect.bottom - headerRect.bottom) + "px";
            olRight.style.top = headerRect.bottom + "px";
          } else if(rowRect.bottom >= contentHeight){
            olRight.style.height = (contentHeight - rowRect.top) + "px";
          }
        }
      } else {
        if(olTop){
          olTop.style.top = contentRect.top + "px";
          olTop.style.left = contentRect.left + "px";
          olTop.style.width = contentWidth + "px";
          if(contentWidth <= 0){
            olTop.style.width = 0;
          }
          olTop.style.height = contentHeight + "px";
          if(contentHeight <= 0){
            olTop.style.height = 0;
          }
        }
        
        if(olBottom){
          olBottom.style.width = 0;
          olBottom.style.height = 0;
        }
        
        if(olLeft){
          olLeft.style.width = 0;
          olLeft.style.height = 0;
        }

        if(olRight){
          olRight.style.width = 0;
          olRight.style.height = 0;
        }
      }
    },
    updateTabIndex(){
     this.currentTab = this.tabIndex;
    },
  },
  watch: {
    deliverableDetail(newDetail, oldDetail){
      this.initializeSocialModal();
      if(newDetail.id !== oldDetail.id){
        this.$emit("modalDetailUpdated");
      }
    },
    tabIndex(){
      this.updateTabIndex();
    },
  },
  created(){
    this.initializeSocialModal();
    this.fetchUserManageSocialCampaigns();
    this.fetchSocialCampaigns();
    let that = this;

    // Listen for ESC key to close the modal
    window.addEventListener('keydown', this.escapeListener);

    // Listen for events to reapply overlay positions
    this.contentDiv = document.querySelector("#content");
    this.contentDiv.addEventListener('scroll', this.overlayListener);
    window.addEventListener('resize', this.overlayListener);
    
    let resize = new ResizeObserver(entries => {
      this.overlayListener();
    });
    resize.observe(document.querySelector("#sidebar"));
    resize.observe(this.contentDiv);
    this.overlayInterval = setInterval(function(){
      that.overlayListener(); 
    }, 200);
  },
  mounted() {
    $('#editSocialModal .modal-content').removeAttr('tabindex');
    if (this.userAbilities && this.deliverableDetail.permissions) {
	    if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) {
	      $('.add-contact-button, .add-resource-button').removeAttr('title').attr('disabled', 'disabled');
	    }
	  }
    this.carouselInterval = 0;

    this.overlayListener();
    let that = this;
    document.body.onclick = function(e) {
      if(e.target.id === "editSocialModal___BV_modal_backdrop_"){
        that.onCloseModal();
      }
    };
    this.$nextTick(function(){
      this.updateTabIndex();
    });
  },
  destroyed(){
    // Remove listener once modal is destroyed
    window.removeEventListener('keydown', this.escapeListener);
    window.removeEventListener('resize', this.overlayListener);
    this.contentDiv.removeEventListener('scroll', this.overlayListener);
    document.body.classList.remove("social-modal-open");
    clearInterval(this.overlayInterval);
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.social-settings-row h3 {
  font-size: 1rem;
  display: inline-block;
  margin-bottom: 0px;
	vertical-align: middle;
	min-height: 25px;
	margin-right: 10px;
	font-weight: 600;
	text-transform:uppercase;
}

.social-settings-row .social-settings-group {
	display:inline-block;
}



.details.post-editor {
	margin-bottom:0px;
}


section.settings .settings-header {
	margin-left:-20px;
}

.settings.campaign-settings {
	padding:20px 25px 25px 25px;
}
.settings.series-settings {
	padding:10px 25px 25px 25px;
	background:#eee;
}

.settings.tag-settings {
	padding:10px 25px;
}

.type-label {
	color: #4C9850;
display:block;
font-weight: 400;
font-size: 1em;
text-transform:uppercase;
}
.group-title {
	font-size:22px;
}
.group-title h1 {
	font-size:22px;
}
.group-title-wrapper {
	width:100%;
	}
.posting-dates-title {
	font-size:1rem;
	text-transform:uppercase;
	font-weight:600;
}
.details.brief-editor {
	margin-bottom:0px !important;
}

.brief-editor h3 {
	font-size:1.2rem;
	text-transform:uppercase;
	font-weight:600;
}

</style>